<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose">
        <div class="row">
            <div class="col-12">
                <table class="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Nombre</th>
                        <th class="text-right">Cantidad</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in items">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.item_name }}</td>
                        <td class="text-right">{{ item.quantity }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XModal from "../../../../components/XModal";
import XButtonCancel from "../../../../components/Form/XButtonCancel";

export default {
    name: 'PurchaseShowItems',
    components: {XButtonCancel, XModal},
    props: ['showDialog', 'purchaseId'],
    data() {
        return {
            title: null,
            loading: false,
            resource: 'purchases',
            items: [],
        }
    },
    methods: {
        async handleOpen() {
            this.title = 'Listado de items';
            this.loading = true;
            await this.$http.get(`/${this.resource}/items/${this.purchaseId}`)
                .then(response => {
                    this.items = response.data;
                });
            this.loading = false;
        },
        clickClose() {
            this.$emit('update:showDialog', false);
        }
    }
}
</script>
